import { useEffect, useState } from "react";
import UnForm from "../../../../Components/Form";
import { faPlus, faTimes, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { ILeadRequest } from "../../../../Interfaces/Vendas/Lead/LeadInterface";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { VendasLeadPostController } from "../../../../Controllers/Vendas/Lead/LeadController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VendasListarOrigensLeadController } from "../../../../Controllers/Vendas/OrigemLead/OrigemLeadController";
import {
    ListarCidadesController,
    ListarEstadosController,
} from "../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarBancosController } from "../../../../Controllers/Geral/ListarBancosController/ListarBancosController";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";
import { ListarUsuariosVendasController } from "../../../../Controllers/Vendas/Usuario/UsuarioController";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ListarProdutosInteresseVendasController } from "../../../../Controllers/Vendas/Produtos/ProdutosController";
import Select from "react-select";

export default function CriarNovoLeadVendas() {
    const history = useHistory();
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);

    const [email, setEmail] = useState<string>("");
    const [telefone, setTelefone] = useState<string>("");

    const [optionsEmpreendimentos, setOptionsEmpreendimentos] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const [empreendimentosSelecionados, setEmpreendimentosSelecionados] =
        useState<Array<number>>([]);

    const [DDI, setDDI] = useState<string>("+55");
    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const { ID_CASO } = useAtendimentoPage();

    const handleToggleAdditionalFields = () => {
        setShowAdditionalFields(!showAdditionalFields);
    };

    const { execute: VendasLeadPost, loading: VendasLeadPostLoading } =
        useAsyncCallback(VendasLeadPostController);

    function handleCadastrarNovoLead(formData: ILeadRequest) {
        VendasLeadPost({
            ...formData,
            NR_TELEFONE: formData.NR_TELEFONE
                ? formData.NR_TELEFONE.replace(/\D/g, "")
                : undefined,
            ID_TIPO_CANAL_ATENDIMENTO: formData.ID_TIPO_CANAL_ATENDIMENTO
                ? formData.ID_TIPO_CANAL_ATENDIMENTO
                : undefined,
            DT_RG_EMISSAO: formData.DT_RG_EMISSAO
                ? formData.DT_RG_EMISSAO
                : undefined,
            DT_NASCIMENTO: formData.DT_NASCIMENTO
                ? formData.DT_NASCIMENTO
                : undefined,
            ID_BANCO: formData.ID_BANCO ? formData.ID_BANCO : undefined,
            ID_CIDADE_COBRANCA: formData.ID_CIDADE_COBRANCA
                ? formData.ID_CIDADE_COBRANCA
                : undefined,
            ID_USUARIO_PROPRIETARIO: formData.ID_USUARIO_PROPRIETARIO
                ? formData.ID_USUARIO_PROPRIETARIO
                : undefined,
            DS_EMAIL: formData.DS_EMAIL ? formData.DS_EMAIL : undefined,
            COD_DDI:
                formData.COD_DDI && formData.NR_TELEFONE
                    ? formData.COD_DDI
                    : undefined,
            COD_DDD: formData.COD_DDD ? formData.COD_DDD : undefined,
            ID_PRODUTOS_INTERESSE:
                empreendimentosSelecionados &&
                empreendimentosSelecionados.length > 0
                    ? empreendimentosSelecionados
                    : undefined,
            DS_ESCOLARIDADE: formData.DS_ESCOLARIDADE
                ? formData.DS_ESCOLARIDADE
                : undefined,
            DS_ESTADO_CIVIL: formData.DS_ESTADO_CIVIL
                ? formData.DS_ESTADO_CIVIL
                : undefined,
            DS_NATURALIDADE: formData.DS_NATURALIDADE
                ? formData.DS_NATURALIDADE
                : undefined,
            DS_NOME_MAE: formData.DS_NOME_MAE
                ? formData.DS_NOME_MAE
                : undefined,
            DS_NOME_PAI: formData.DS_NOME_PAI
                ? formData.DS_NOME_PAI
                : undefined,
            DS_SEXO: formData.DS_SEXO ? formData.DS_SEXO : undefined,
            DS_RG: formData.DS_RG ? formData.DS_RG : undefined,
            DS_RG_ORGAO_EMISSOR: formData.DS_RG_ORGAO_EMISSOR
                ? formData.DS_RG_ORGAO_EMISSOR
                : undefined,
            DS_RG_UF_EMISSOR: formData.DS_RG_UF_EMISSOR
                ? formData.DS_RG_UF_EMISSOR
                : undefined,
            ID_ESTADO: formData.ID_ESTADO ? formData.ID_ESTADO : undefined,
            NR_CPF: formData.NR_CPF ? formData.NR_CPF : undefined,
        }).then(() => {
            if (!ID_CASO) {
                history.push(ACESSOS.VENDAS.TELAS.GESTAO_OPORTUNIDADES.DS_PATH);
            }
        });
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarProdutosInteresseVendasController(0),
        []
    );

    useEffect(() => {
        setOptionsEmpreendimentos(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_PRODUTO,
                value: empreendimento.ID_PRODUTO,
            }))
        );
    }, [listarEmpreendimentos]);

    return (
        <div className="card card-body">
            <div className="d-flex justify-content-center align-items-center mt-2">
                <h1>DADOS DO {!ID_CASO ? "LEAD" : "PROPONENTE"}</h1>
            </div>
            <div className="row w-100 justify-content-center">
                <div className="col-12 col-md-6 col-lg-4 py-6">
                    <UnForm handleSubmit={handleCadastrarNovoLead}>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-6">
                                    <label>Nome</label>
                                    <UnForm.Input
                                        name="DS_NOME"
                                        type="text"
                                        registerOptions={{
                                            required: "Insira um nome",
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <label>Email</label>
                                    <UnForm.Input
                                        name="DS_EMAIL"
                                        type="email"
                                        registerOptions={{
                                            required:
                                                telefone.length === 0
                                                    ? "Insira um email"
                                                    : false,
                                        }}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="row">
                                <div className="col-4">
                                    <label>DDI</label>
                                    <UnForm.Input
                                        name="COD_DDI"
                                        type="tel"
                                        value={DDI}
                                        onChange={(e) => {
                                            setDDI(e.target.value);
                                        }}
                                        maxLength={3}
                                        className="form-control"
                                        defaultValue={"+55"}
                                        registerOptions={{
                                            required:
                                                email.length === 0
                                                    ? "Insira um DDI"
                                                    : false,
                                        }}
                                    />
                                </div>
                                <div className="col-4">
                                    <label>DDD</label>
                                    <UnForm.Input
                                        name="COD_DDD"
                                        type="tel"
                                        registerOptions={{
                                            required:
                                                DDI === "+55" &&
                                                email.length === 0
                                                    ? "Insira um DDD"
                                                    : false,
                                        }}
                                        maxLength={3}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-4">
                                    <label>Telefone</label>
                                    <UnForm.Input
                                        name="NR_TELEFONE"
                                        type="tel"
                                        maxLength={9}
                                        className="form-control"
                                        registerOptions={{
                                            required:
                                                email.length === 0
                                                    ? "Insira um Telefone"
                                                    : false,
                                        }}
                                        onChange={(e) => {
                                            setTelefone(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Origem do Lead</label>
                            <UnForm.LazySelect
                                name="ID_ORIGEM_LEAD"
                                controller={VendasListarOrigensLeadController}
                                getDS={(origem) => origem.DS_ORIGEM_LEAD_COMP}
                                getKeyValue={(origem) => origem.ID_ORIGEM_LEAD}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <button
                                className="btn btn-light my-3"
                                onClick={handleToggleAdditionalFields}
                                type="button"
                            >
                                {showAdditionalFields ? (
                                    <>
                                        <FontAwesomeIcon icon={faTimes} />{" "}
                                        Fechar informações adicionais
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faPlus} />{" "}
                                        Adicionar informações adicionais
                                    </>
                                )}
                            </button>
                        </div>
                        {showAdditionalFields && (
                            <>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>CPF</label>
                                            <UnForm.Input
                                                name="NR_CPF"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Corretor</label>
                                            <UnForm.LazySelect
                                                controller={
                                                    ListarUsuariosVendasController
                                                }
                                                getDS={(equipe) =>
                                                    equipe.DS_NOME
                                                }
                                                getKeyValue={(equipe) =>
                                                    equipe.ID_USUARIO
                                                }
                                                className="form-control"
                                                name="ID_USUARIO_PROPRIETARIO"
                                            >
                                                <option></option>
                                            </UnForm.LazySelect>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <UnForm.LazySelect
                                                controller={
                                                    listarCanalAtendimento
                                                }
                                                getDS={(ca) =>
                                                    ca.DS_TIPO_CANAL_ATENDIMENTO
                                                }
                                                getKeyValue={(ca) =>
                                                    ca.ID_TIPO_CANAL_ATENDIMENTO
                                                }
                                                name="ID_TIPO_CANAL_ATENDIMENTO"
                                                label="Canal de Atendimento"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>RG</label>
                                            <UnForm.Input
                                                name="DS_RG"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Órgão Emissor RG</label>
                                            <UnForm.Input
                                                name="DS_RG_ORGAO_EMISSOR"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>UF Emissor RG</label>
                                            <UnForm.Input
                                                name="DS_RG_UF_EMISSOR"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Dt. Emissão RG</label>
                                            <UnForm.Input
                                                name="DT_RG_EMISSAO"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Nome do Pai</label>
                                            <UnForm.Input
                                                name="DS_NOME_PAI"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Nome da Mãe</label>
                                            <UnForm.Input
                                                name="DS_NOME_MAE"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Data de Nascimento</label>
                                            <UnForm.Input
                                                name="DT_NASCIMENTO"
                                                type="date"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Sexo</label>
                                            <UnForm.Select name="DS_SEXO">
                                                <option></option>
                                                <option>Masculino</option>
                                                <option>Feminino</option>
                                                <option>Outro</option>
                                            </UnForm.Select>
                                        </div>
                                        <div className="col-6">
                                            {" "}
                                            <UnForm.LazySelect
                                                controller={
                                                    ListarBancosController
                                                }
                                                getDS={(ds) => ds.DS_BANCO}
                                                getKeyValue={(key) =>
                                                    key.ID_BANCO
                                                }
                                                label="Banco"
                                                name="ID_BANCO"
                                            >
                                                <option></option>
                                            </UnForm.LazySelect>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Estado Civil</label>
                                            <UnForm.Input
                                                name="DS_ESTADO_CIVIL"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Escolaridade</label>
                                            <UnForm.Input
                                                name="DS_ESCOLARIDADE"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Naturalidade</label>
                                            <UnForm.Input
                                                name="DS_NATURALIDADE"
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Cidade de Cobrança</label>
                                            <UnForm.LazySelect
                                                controller={
                                                    ListarCidadesController
                                                }
                                                getDS={(estado) =>
                                                    estado.DS_CIDADE
                                                }
                                                getKeyValue={(estado) =>
                                                    estado.ID_CIDADE
                                                }
                                                name="ID_CIDADE_COBRANCA"
                                                fatherName="ID_ESTADO"
                                            >
                                                <option value=""></option>
                                            </UnForm.LazySelect>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Estado de cobrança</label>
                                            <UnForm.LazySelect
                                                controller={
                                                    ListarEstadosController
                                                }
                                                getDS={(estado) =>
                                                    estado.DS_ESTADO
                                                }
                                                getKeyValue={(estado) =>
                                                    estado.ID_ESTADO
                                                }
                                                name="ID_ESTADO"
                                            >
                                                <option value=""></option>
                                            </UnForm.LazySelect>
                                        </div>
                                        <div className="col-6">
                                            <label>Produto de Interesse</label>
                                            <Select
                                                name="ID_PRODUTOS_INTERESSE"
                                                options={optionsEmpreendimentos}
                                                isClearable
                                                isMulti
                                                onChange={(e) => {
                                                    setEmpreendimentosSelecionados(
                                                        e?.map(
                                                            (empreendimento) =>
                                                                empreendimento.value
                                                        )
                                                    );
                                                }}
                                                components={{
                                                    DropdownIndicator: () =>
                                                        null,
                                                    IndicatorSeparator: () =>
                                                        null,
                                                }}
                                                styles={customStyles}
                                                placeholder={""}
                                                noOptionsMessage={() =>
                                                    "Nenhuma opção"
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <hr />

                        <div className="d-flex justify-content-center align-items-center">
                            <div>
                                <UnForm.SubmitButton
                                    className="mr-2"
                                    color="success"
                                    icon={faUserPlus}
                                    loading={VendasLeadPostLoading}
                                    disabled={VendasLeadPostLoading}
                                    iconSize="sm"
                                    loadingSize="sm"
                                >
                                    Cadastrar {!ID_CASO ? "Lead" : "Proponente"}
                                </UnForm.SubmitButton>
                            </div>
                            {!ID_CASO && (
                                <div>
                                    <button
                                        className="btn btn-light-dark"
                                        type="button"
                                        disabled={VendasLeadPostLoading}
                                        onClick={() => {
                                            history.push(
                                                ACESSOS.VENDAS.TELAS
                                                    .GESTAO_OPORTUNIDADES
                                                    .DS_PATH
                                            );
                                        }}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            )}
                        </div>
                    </UnForm>
                </div>
            </div>
        </div>
    );
}
